import React, { useEffect, useState, useCallback } from 'react';
import './style.css';

export default function Toast({ 
  type = 'info', 
  message, 
  duration = 4000, 
  onClose, 
  position = 'top-right',
  avatar = null,
  title = null,
  actions = null,
  showProgress = true 
}) {
  const [progress, setProgress] = useState(100);
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      onClose && onClose();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    if (showProgress && duration > 0) {
      const interval = setInterval(() => {
        setProgress(prev => {
          const newProgress = prev - (100 / (duration / 100));
          if (newProgress <= 0) {
            clearInterval(interval);
            handleClose();
            return 0;
          }
          return newProgress;
        });
      }, 100);

      return () => clearInterval(interval);
    } else if (duration > 0) {
      const timer = setTimeout(handleClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, showProgress, handleClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'message':
        return '💬';
      case 'call':
        return '📞';
      default:
        return '📢';
    }
  };

  if (!isVisible) return null;

  
  return (
    <div className={`toast toast-${type} toast-${position} ${isVisible ? 'toast-enter' : 'toast-exit'}`}>
      <div className="toast-content">
        {avatar && (
          <div className="toast-avatar">
            <img src={avatar} alt="Avatar" />
          </div>
        )}
        
        <div className="toast-icon">
          {getIcon()}
        </div>
        
        <div className="toast-body">
          {title && <div className="toast-title">{title}</div>}
          <div className="toast-message">{message}</div>
        </div>
        
        {actions && (
          <div className="toast-actions">
            {actions}
          </div>
        )}
        
        <button className="toast-close" onClick={handleClose}>
          ×
        </button>
      </div>
      
      {showProgress && duration > 0 && (
        <div className="toast-progress">
          <div 
            className="toast-progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
} 